var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayerFullScreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165.323,
    height: 118.323,
    viewBox: "0 0 165.323 118.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-fullscreen",
    "data-name": "Icon material-fullscreen",
    d: "M24.4,83.564H7.5v42.258H49.758v-16.9H24.4ZM7.5,49.758H24.4V24.4H49.758V7.5H7.5Zm148.419,59.161H130.564v16.9h42.258V83.564h-16.9ZM130.564,7.5V24.4h25.355V49.758h16.9V7.5Z",
    transform: "translate(-7.5 -7.5)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayerFullScreen);
export default __webpack_public_path__ + "static/media/playerFullScreen.31b92e3f5da3daccc1089472b0faccd6.svg";
export { ForwardRef as ReactComponent };